<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="buttonauthDetail" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<auth :extra="authextra" v-if="authShow" @submit="authSubmit" @back="authShow=false" />	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "1000",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$input",
					"field": "code",
					"title": "模块编码",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "name",
					"title": "模块名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import auth from '@_system/components/auth/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				authShow:false,
				modal_title: '编辑',
				modal_width:800,
				modal_height:600,
				authextra: {},
				currentrow:null
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			authModal(row) {
				this.currentrow = row
				this.authextra.value = {
					auth: this.currentrow.auth?this.currentrow.auth:null
				}
				this.authShow = true
			},
			authSubmit(e){
				this.currentrow.auth = e.data
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 400
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'buttoncode',
						title: '按钮编码',
						editRender: {
							name: '$input',
							props: {
								
							},
							events: {
								
							}
						},
					}, 
					{
						field: 'buttonname',
						title: '按钮名称',
						editRender: {
							name: '$input',
							props: {
								
							},
							events: {
								
							}
						},
					},
					{
						field: 'order',
						title: '排序',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:0
							},
							events: {
								
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.authModal(row)}}>权限</el-button>,
									<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					buttoncode: [{
						required: true
					}],
					buttonname: [{
						required: true
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					if(this.sourceData.auth){						
						resolve({
							list: this.sourceData.auth
						})
					}else{
						resolve({
							list: []
						})
					}

				})
			},
			modal_init(){
				this.sourceData = JSON.parse(JSON.stringify(this.row))
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
				this.getgrid().commitProxy('query')
			},
			getgrid(){
				return this.$refs.buttonauthDetail
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					this.getgrid().validate(true, (res) => {
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))
							let detail = this.getgrid().getTableData().visibleData
							let data = submitData
							detail = JSON.parse(JSON.stringify(detail))
							detail.forEach((item)=>{
								delete(item._X_ROW_KEY)
								delete(item._X_ROW_CHILD)
							})
							data.auth = detail
							if(!this.row.id){
								this.$api.buttonauth.save(data).then(() => {
									this.$emit('success', {
										data: JSON.stringify(data)
									})
									this.modal_cancel()
								})
							}else{
								this.$api.buttonauth.update(this.row.id,data).then(() => {
									this.$emit('success', {
										data: JSON.stringify(data)
									})
									this.modal_cancel()
								})
							}


							console.log(data)
						} else {
							for (let i in res) {
								let content = res[i][0].rule.$options.content
								let message = res[i][0].rule.$options.message
								if(content){
									this.$message.error(content)
								}else if(message){
									this.$message.error(message)
								}else{
									this.$message.error('缺少必填项：' + res[i][0].column.title)
								}
								
							}
						}
					})
				})
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			auth
		}
	}
</script>